      
(function () {
  var path = window.location.pathname.replace(/\/+$/, '') || '/';
  var country =
    window.ShopifyVars &&
    window.ShopifyVars.context &&
    window.ShopifyVars.context.country
      ? window.ShopifyVars.context.country
      : 'unknown';
  var cacheKey = country + '::' + path;
  var hasView = new URLSearchParams(window.location.search).has('view');
  var canHaveContentExperiment =
  path === '/' ||
  path.indexOf('/products') === 0 ||
  path.indexOf('/collections') === 0 ||
  path.indexOf('/pages') === 0;
  
  if (hasView || !canHaveContentExperiment) {
    var unusedStyle = document.getElementById('ab-prehide-style');
    if (unusedStyle) unusedStyle.remove();
    return;
  }

  document.documentElement.classList.add('ab-prehide');
  
  try {
    var cache = JSON.parse(sessionStorage.getItem('ab_content_experiment_cache') || '{}');
    var cachedData = cache[cacheKey];
    var cachedTemplateSuffix = cachedData && cachedData.template_suffix;
    
    if (cachedData && cachedTemplateSuffix === '') {
      var controlStyle = document.getElementById('ab-prehide-style');
      if (controlStyle) controlStyle.remove();
      return;
    }
    
    if (cachedData && cachedTemplateSuffix) {
      var cachedUrl = new URL(window.location.href);
      cachedUrl.searchParams.set('view', cachedTemplateSuffix);
      window.location.replace(cachedUrl.toString());
      return;
    }
  } catch (e) {
    console.warn('[ABStudio] Failed to read prehide cache:', e);
  }

  if (document.getElementById('ab-loader')) return;
  
  var loader = document.createElement('div');
  loader.id = 'ab-loader';
  loader.setAttribute('role', 'status');
  loader.setAttribute('aria-live', 'polite');
  loader.textContent = 'Loading';
  document.documentElement.appendChild(loader);
  
  window.__abPrehideTimer = setTimeout(function () {
    if (window.__abMainStarted) return;
    
    document.documentElement.classList.remove('ab-prehide');
    var staleLoader = document.getElementById('ab-loader');
    var staleStyle = document.getElementById('ab-prehide-style');
    if (staleLoader) staleLoader.remove();
    if (staleStyle) staleStyle.remove();
  }, 3000);
})();

    